<template>
  <!-- document.querySelectorAll('[data-id="123"]') -->
  <div id="question-options">
    <div
      v-bind:id="item.QuestionID"
      name="formitem"
      v-for="(item) in QuestionnaireUserOptionList"
      :key="item.QuestionID"
    >
      <form action ref="questionOptions">
        <div v-if="item.QuestionType!==5">
          <div style="padding:10px 12px 4px;">
            <span
              v-if="item.IsMust"
              style="display:inline-block;
                    padding: 1px;
                    color:red"
            >*</span>
            <span>{{item.SortOrder+'. '}}</span>
            {{item.QuestionName}}
          </div>

          <van-cell-group v-if="item.QuestionType === 1" id="danxuan">
            <van-cell v-for="(opItem,index) in item.Options" :key="opItem.QuestionID" class="cell-yaya">
              <label>{{opItem.QuestionOptionName}}</label>
              <van-field
                v-if="opItem.IsFillBlank"
                v-model="item.UserOptions[index].FillBlankContent"
                placeholder="请输入..."
                clearable
                :name="opItem.QuestionOptionID"
                ref="radioInput"
                @blur="radioBlur($event,opItem,item.UserOptions[0].FillBlankContent,item.QuestionType,opItem.QuestionOptionID)"
              />
              <van-radio-group v-model="item.radioChecked[0].QuestionOptionID" class="danxuan">
                <van-radio
                  checked-color="#07c160"
                  :name="opItem.QuestionOptionID===item.radioChecked[0].QuestionOptionID?item.radioChecked[0].QuestionOptionID:opItem.QuestionOptionID"
                  ref="radio"
                  @click="clickChoose(opItem,item.QuestionType,item.QuestionID)"
                >
                  <img
                    slot="icon"
                    ref="radioImg"
                    :id="opItem.QuestionOptionID"
                    slot-scope="props"
                    :src="props.checked ? activeIcon : inactiveIcon"
                  />
                </van-radio>
              </van-radio-group>
            </van-cell>
          </van-cell-group>

          <van-cell-group v-if="item.QuestionType === 2">
            <van-cell
              v-for="(opItem,index) in item.Options"
              :key="opItem.QuestionID"
              class="cell-yaya"
            >
              <label>{{opItem.QuestionOptionName}}</label>
              <van-field
                placeholder="请输入..."
                v-model="item.UserOptions[index].FillBlankContent"
                v-if="opItem.IsFillBlank"
                clearable
                @blur="radioBlur($event,opItem,item.UserOptions[index].FillBlankContent,item.QuestionType,opItem.QuestionOptionID)"
              />
              <van-checkbox-group v-model="result">
                <van-checkbox
                  checked-color="#07c160"
                  :name="opItem.QuestionOptionID"
                  class="danxuan"
                  @click="clickChoose(opItem,item.QuestionType,item.QuestionID)"
                ></van-checkbox>
              </van-checkbox-group>
            </van-cell>
          </van-cell-group>

          <van-cell-group v-if="item.QuestionType === 3">
            <van-cell class="cell-yaya">
              <van-field
                v-model="item.UserOptions[0].QuestionOptionContent"
                placeholder="请输入..."
                type="textarea"
                name="opContent"
                ref="textarea"
              />
            </van-cell>
          </van-cell-group>

          <div v-if="item.QuestionType === 4">
            <van-cell-group
              v-for="(colItem) in item.Columns"
              :key="colItem.QuestionID"
              style="padding:10px 12px 0;"
            >
              <label>{{colItem.QuestionColumnName}}</label>
              <van-cell
                v-for="(rowItem,rindex) in item.Options"
                :key="rindex"
                class="cell-yaya"
              >
                <div style="line-height:50px">{{rowItem.QuestionOptionName}}</div>
                <van-field
                  id="field"
                  v-model="item.UserOptions[0].FillBlankContent"
                  clearable
                  @blur="radioBlur($event,rowItem,item.UserOptions[0].FillBlankContent,item.QuestionType,rowItem.QuestionOptionID,colItem.QuestionColumnID)"
                  name="opContent"
                  ref="juzhengInput"
                />
              </van-cell>
            </van-cell-group>
          </div>
        </div>
      </form>
    </div>
    <div>
      <van-button type="primary" size="large" @click.native="prevPage" v-if="page!==1">上一页</van-button>
      <van-button
        type="primary"
        size="large"
        @click.native="submitAnswer"
        v-cloak
      >{{page >= questionnaireRow.PageCount ? "提交":"下一页" }}</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      QuestionnaireUserOptionList: [],
      questionnaireRow: {},
      radio: "1",
      checked: true,
      result: [],
      textareaClass: document.getElementsByTagName("textarea"),
      // this.activeIcon = require("@/assets/wisdomOffice/radio.png")
      activeIcon: require("@/assets/wisdomOffice/radio.png"),
      inactiveIcon: "",
      UserOptions: [],
      lockId: "",
      isValid: true,
      clickRadio: false,
      clickCheckde: false,
      radioChecked:{},
      checkboxChecked:{}
    };
  },
  components: {},
  created: function() {
    this.getRow();
  },
  mounted: function() {},
  methods: {
    //获取父级页面传过来的数据
    getRow: function() {
      this.questionnaireRow = this.$route.query.questionnaireRow;
      this.loadList();
    },
    //请求数据
    async loadList() {
      let res = await this.xyapi.get(
        this.$store.state.apiPath +
          "/api/QuestionnaireUser/GetForCurrUserOptions",
        {
          questionnaireID: this.questionnaireRow.QuestionnaireID,
          pageIndex: this.page
        }
      );

      if (res && res.data && res.data.length !== 0) {
        this.$nextTick(function() {
          res.data.forEach((ele) => {
            if (ele.QuestionType === 1) {
              this.loadListType1(ele)
            }
            if (ele.QuestionType === 2) {
              if(ele.UserOptions.length!==0){
                this.checkboxChecked = JSON.parse(JSON.stringify(ele.UserOptions));
                this.checkboxChecked.forEach((upItem)=>{
                  if(this.result.indexOf(upItem.QuestionOptionID) === -1){
                      this.result.push(upItem.QuestionOptionID);
                  }
                })
              }
              ele.UserOptions = [];
              ele.Options.forEach((item) => {
                ele.UserOptions.push({
                  FillBlankContent: "",
                  QuestionOptionContent: "",
                  QuestionOptionID: item.QuestionOptionID,
                  QuestionID: item.QuestionID
                });
              });
              if(this.checkboxChecked[0]!==undefined){
                for(let j = 0;j < this.checkboxChecked.length;j++){
                  for(let i = 0;i < ele.UserOptions.length;i++){
                    if(ele.UserOptions[i].QuestionOptionID === this.checkboxChecked[j].QuestionOptionID){
                      ele.UserOptions.splice(i,1);
                      ele.UserOptions.splice(i,0,this.checkboxChecked[j]);
                    }
                  }
                }
              }
              ele['checkboxChecked'] = this.checkboxChecked[0]!==undefined?this.checkboxChecked : ele.UserOptions;
            }
            if (ele.QuestionType === 3) {
              if(ele.UserOptions&&ele.UserOptions.length!==0){
                // var curItemDom = $(xy.string.format("#XyQuestionnaireUserOptions div#{0}[name=formitem]", ele.QuestionID));
                if (ele.UserOptions[0].QuestionOptionContent.length > 0) {
                  this.textareaClass.value =
                    ele.UserOptions[0].QuestionOptionContent;
                }
              }
            }
            if (ele.UserOptions.length === 0&&ele.QuestionType!==1) {
              ele.UserOptions.push({
                FillBlankContent: "",
                QuestionOptionContent: "",
                QuestionOptionID: ''
              });
            }
          });
          this.QuestionnaireUserOptionList = res.data;
          console.log('请求',this.result);
        });
      } else {
        this.xy.msgInfo(res ? res.msg : "服务器出错");
      }
    },
    loadListType1(ele){
      if(ele.UserOptions.length!==0){
        this.radioChecked = Object.assign({}, this.radioChecked, ele.UserOptions)       
      }
      ele.UserOptions = [];
      
        if(this.radioChecked[0]!==undefined){
          ele.Options.forEach((item) => {
            //设置单选状态upItem
            ele.UserOptions.push({
              FillBlankContent: "",
              QuestionOptionContent: "",
              QuestionOptionID: item.QuestionOptionID,
              QuestionID: item.QuestionID
            });
          });
        }else{
          ele.Options.forEach(() => {
            //设置单选状态upItem
            ele.UserOptions.push({
              FillBlankContent: "",
              QuestionOptionContent: "",
              QuestionOptionID: '',
              QuestionID: ''
            });
          });          
        }

      for(let i = 0;i < ele.UserOptions.length;i++){
        if(this.radioChecked[0]!==undefined){
          if(ele.UserOptions[i].QuestionOptionID === this.radioChecked[0].QuestionOptionID){
            ele.UserOptions.splice(i,1);
            ele.UserOptions.splice(i,0,this.radioChecked[0]);
          }                  
        }
      }
      ele['radioChecked'] = this.radioChecked[0]!==undefined?this.radioChecked : ele.UserOptions;
    },
    //上一页
    prevPage: function() {
      if (this.page > 1) this.page -= 1;
      this.loadList();
    },
    radioBlur(e,item, value, type, QuestionOptionID, QuestionColumnID) {
      // console.log(e,e.path[0].value,item, value, type, QuestionOptionID, QuestionColumnID)
      // input
      // if (value) {
        let config = false;
        this.QuestionnaireUserOptionList.forEach(Qitem => {
          if (
            Qitem.QuestionType === type &&
            Qitem.QuestionID === item.QuestionID
          ) {
            if (this.UserOptions.length !== 0) {
              for (let i = 0; i < this.UserOptions.length; i++) {
                if (
                  this.UserOptions[i].type === type &&
                  this.UserOptions[i].QuestionID === item.QuestionID
                ) {
                  config = true;
                  if(this.UserOptions[i].QuestionOptionID === item.QuestionOptionID){
                    this.UserOptions[i].FillBlankContent = e.path[0].value.replace(/\s*/g,"");
                  }else if(type === 1){
                    this.UserOptions[i].FillBlankContent = '';
                  }
                }
              }
              if (!config) {
                this.UserOptions.push({
                  UserQuestionnaireID: this.questionnaireRow
                    .UserQuestionnaireID,
                  QuestionID: item.QuestionID,
                  QuestionOptionID: QuestionOptionID,
                  QuestionColumnID: QuestionColumnID || 0,
                  FillBlankContent: e.path[0].value.replace(/\s*/g, ""),
                  QuestionOptionContent: "",
                  type: type
                });
              }
            } else {
              this.UserOptions.push({
                UserQuestionnaireID: this.questionnaireRow.UserQuestionnaireID,
                QuestionID: item.QuestionID,
                QuestionOptionID: QuestionOptionID,
                QuestionColumnID: QuestionColumnID || 0,
                FillBlankContent: e.path[0].value.replace(/\s*/g, ""),
                QuestionOptionContent: "",
                type: type
              });
            }
            if(Qitem.UserOptions.length !== 0){//设置已有的默认的
              for(let i = 0;i < Qitem.UserOptions.length;i++){
                // console.log(Qitem.UserOptions[i].QuestionOptionID , QuestionOptionID)
                if(Qitem.UserOptions[i].QuestionOptionID === QuestionOptionID){
                  Qitem.UserOptions[i].FillBlankContent = e.path[0].value;
                  break;
                }
              }              
            }
          }
        });
      // }
      console.log("input框", this.UserOptions);
    },
    clickChoose(item, type, QuestionID) {
      // 点击选择
      this.QuestionnaireUserOptionList.forEach(Qitem => {
        // console.log(Qitem,'?????????')
        if (Qitem.QuestionType === type && Qitem.QuestionID === QuestionID) {
          for (let i = 0; i < Qitem.Options.length; i++) {
            if (item.QuestionOptionID === Qitem.Options[i].QuestionOptionID) {
              if (type === 1) {
                this.changeRadio(Qitem.Options[i], Qitem.UserOptions);
              } else if (type === 2) {
                this.changeCheckbox(Qitem.Options[i], Qitem.UserOptions);
              }
            }
          }
        }
      });
    },
    changeRadio(item, Qitem) {
      // 单选框
      // console.log(item);
      if (this.lockId === item.QuestionOptionID) return; //控制多次点击单选框
      // console.log('进的来吗');

      let FillBlankContent =
        Qitem.length !== 0 &&
        Qitem[0].QuestionOptionID === item.QuestionOptionID
          ? Qitem[0].FillBlankContent
          : "";
      if (this.UserOptions.length === 0) {
        this.configObject(item, 1, FillBlankContent);
      } else {
        let create = true;
        let editNum = 0;
        for (let i = 0; i < this.UserOptions.length; i++) {
          if (this.UserOptions[i].QuestionID === item.QuestionID) {
            create = false;
            editNum = i;
          }
        }
        if (!create) {
          // console.log('??????edit',item.QuestionOptionID,this.UserOptions[editNum].QuestionOptionID)
          let obj = {
            UserQuestionnaireID: this.questionnaireRow.UserQuestionnaireID,
            QuestionID: item.QuestionID,
            QuestionOptionID: item.QuestionOptionID,
            QuestionColumnID: 0,
            FillBlankContent:
              item.QuestionOptionID ===
              this.UserOptions[editNum].QuestionOptionID
                ? this.UserOptions[editNum].FillBlankContent
                : FillBlankContent,
            QuestionOptionContent: "",
            checked: true,
            type: 1
          };
          this.UserOptions.splice(editNum, 1);
          this.UserOptions.push(obj);
        } else {
          // console.log('??????create')
          this.configObject(item, 1, FillBlankContent);
        }
      }
      this.clickRadio = true;
      this.lockId = item.QuestionOptionID;
      console.log("单选框", this.UserOptions);
    },
    arrI(arr,item){
      for(let i = 0;i <arr.length;i++){
        if(arr[i].QuestionOptionID === item){
          return i;
        }
      }
    },
    changeCheckbox(item, Qitem) {
        for(let i =0;i < this.checkboxChecked.length;i++){
          if(this.checkboxChecked[i].QuestionOptionID === item.QuestionOptionID){//原来已经选中了删除
          console.log(this.checkboxChecked[i].QuestionOptionID , item.QuestionOptionID,'原来已经选中了删除')
            this.checkboxChecked.splice(i,1)
            return;
          }
        }
      // 复选框
      let FillBlankContent =
        Qitem.length !== 0 && Qitem.QuestionOptionID === item.QuestionOptionID
          ? Qitem[0].FillBlankContent
          : "";
      if (this.UserOptions.length === 0) {
        this.configObject(item, 2, FillBlankContent);
      } else {
        let DeleteNum = 0;
        let Delete = false;
        let create = true;
        let arr = [];
        for (let i = 0; i < this.UserOptions.length; i++) {
          // console.log(this.UserOptions[i].QuestionID , item.QuestionID,this.UserOptions[i].type)
          if (this.UserOptions[i].QuestionID === item.QuestionID) {
            create = false;
            // console.log(this.UserOptions[i].QuestionOptionID , item.QuestionOptionID)
            if (
              this.UserOptions[i].QuestionOptionID === item.QuestionOptionID
            ) {
              if (this.UserOptions[i].checked) {
                // console.log(this.UserOptions[i].QuestionOptionID , item.QuestionOptionID,'删除？')
                DeleteNum = i;
                Delete = true;
                break;
              }
            }
            arr.push(this.UserOptions[i].QuestionOptionID)
          }
        }
              
        if (Delete) {
          // console.log('?delete')
          this.UserOptions.splice(DeleteNum, 1);
        }else{
          if (create) {
            this.configObject(item, 2, FillBlankContent);
          }else{
            if(arr.indexOf(item.QuestionOptionID)===-1){
              this.configObject(item, 2, FillBlankContent);
            }            
          }
        }
      }
      this.clickCheckde = true;
      console.log("复选框", this.UserOptions);
    },
    configObject(item, type, FillBlankContent) {
      this.UserOptions.push({
        UserQuestionnaireID: this.questionnaireRow.UserQuestionnaireID,
        QuestionID: item.QuestionID,
        QuestionOptionID: item.QuestionOptionID,
        QuestionColumnID: 0,
        FillBlankContent: FillBlankContent || "",
        QuestionOptionContent: "",
        checked: true,
        type: type
      });
    },
    //设置 添加试题界面
    async submitAnswer() {
      this.isValid = true;
      var submitModle = {
        UserQuestionnaireID: this.questionnaireRow.UserQuestionnaireID,
        QuestionnaireID: this.questionnaireRow.QuestionnaireID,
        SubmitStatus: this.page >= this.questionnaireRow.PageCount,
        UserOptions: new Array()
      };
      //   //获取提交值
      this.QuestionnaireUserOptionList.forEach(qItem => {
        if (qItem.QuestionType === 1) {
          this.QuestionType1Fn(qItem);
        }
        if (qItem.QuestionType === 2) {
          this.QuestionType2Fn(qItem);
        }
        if (qItem.QuestionType === 3) {
          this.QuestionType3Fn(qItem);
        }
        if (qItem.QuestionType === 4) {
          this.QuestionType4Fn(qItem);
        }
      });
      this.page >= this.questionnaireRow.PageCount;
      submitModle.UserOptions = this.UserOptions;
      // console.log(this.UserOptions,'===========',submitModle.UserOptions);
      this.clickButton(submitModle);
    },
    setResult(){
      this.result = [];
      for(let i = 0;i < this.UserOptions.length;i++){
        if(this.UserOptions[i].type===2){
          this.result.push(this.UserOptions[i].QuestionOptionID)
        }
      }
    },
    QuestionType1Fn(qItem) {
      let checked = false;
      if(!this.clickRadio){//没有点击过单选框本来就有
          if(this.QuestionnaireUserOptionList!==0){
            for (let i = 0; i < qItem.UserOptions.length; i++) {
              if (qItem.UserOptions[i].QuestionID === qItem.radioChecked[0].QuestionID) {
                checked = qItem.UserOptions.length===0?false:true;
              }
            }
        }
      }else{
        if(this.UserOptions!==0){
          for (let i = 0; i < this.UserOptions.length; i++) {
            if (this.UserOptions[i].QuestionID === qItem.Options[0].QuestionID || 
                qItem.radioChecked[0].QuestionID===qItem.Options[0].QuestionID &&
                qItem.radioChecked[0].QuestionID!==this.UserOptions[i].QuestionID) {
              checked = true;
            }
          }
        }
      }

      if (!checked) {
        if (qItem.IsMust) {
          this.xy.msgError("请填写必答题！");
          this.isValid = false;
          return false;
        } else {
          return true;
        }
      }
    },
    QuestionType2Fn(qItem) {
      let checkedList = [];
      if(!this.clickCheckde){//没有点击过复选框本来就有
        if(qItem.checkboxChecked.length!==0){
            for (let i = 0; i < qItem.checkboxChecked.length; i++) {
              if (qItem.checkboxChecked[i].QuestionID === qItem.Options[0].QuestionID) {
                checkedList.push(true);
              }
            }
        }
      }else{
        if(this.UserOptions!==0){
          for (let i = 0; i < this.UserOptions.length; i++) {
              if (this.UserOptions[i].QuestionID === qItem.Options[0].QuestionID) {
                checkedList.push(this.UserOptions[i].QuestionOptionID);
              }
          }
      }}
      if (checkedList.length === 0) {
        if (qItem.IsMust) {
          this.xy.msgError("请填写必答题！");
          this.isValid = false;
          return false;
        }
      }
    },
    QuestionType3Fn(qItem) {
      var textareaNum = 0;
      textareaTxt =
        typeof textareaTxt === "string" ? textareaTxt.replace(/\s*/g, "") : "";
      let textareaTxt = this.textareaClass[textareaNum].value;
      if (textareaTxt.length === 0) {
        if (qItem.IsMust) {
          this.xy.msgError("请填写必答题！");
          this.isValid = false;
          return false;
        } else {
          textareaNum += 1;
          return true;
        }
      }
      textareaNum += 1;
      if (this.UserOptions.length !== 0) {
        for (let i = 0; i < this.UserOptions.length; i++) {
          if (qItem.UserOptions.length !== 0) {
            if (
              this.UserOptions[i].QuestionID === qItem.UserOptions[0].QuestionID
            ) {
              let obj = {
                UserQuestionnaireID: this.questionnaireRow.UserQuestionnaireID,
                QuestionID: qItem.QuestionID,
                QuestionOptionID: qItem.QuestionnaireID,
                QuestionColumnID: 0,
                FillBlankContent: "",
                QuestionOptionContent: textareaTxt,
                type: 3
              };
              this.UserOptions.splice(i, 1);
              this.UserOptions.push(obj);
              break;
            }
          } else {
            this.textareaObj(qItem, textareaTxt);
            break;
          }
        }
      } else {
        this.textareaObj(qItem, textareaTxt);
      }
    },
    QuestionType4Fn(qItem) {
      let containEmpty = "";
      if (qItem.UserOptions.length !== 0) {
        let FillBlankContent = qItem.UserOptions[0].FillBlankContent;
        containEmpty =
          typeof FillBlankContent === "string"
            ? FillBlankContent.replace(/\s*/g, "")
            : "";
      }
      if (containEmpty === "") {
        if (qItem.IsMust) {
          this.xy.msgError("请填写必答题！");
          this.isValid = false;
          return false;
        } else {
          return true;
        }
      }
    },
    textareaObj(qItem, textareaTxt) {
      this.UserOptions.push({
        UserQuestionnaireID: this.questionnaireRow.UserQuestionnaireID,
        QuestionID: qItem.QuestionID,
        QuestionOptionID: qItem.QuestionnaireID,
        QuestionColumnID: 0,
        FillBlankContent: "",
        QuestionOptionContent: textareaTxt,
        type: 3
      });
    },
    async clickButton(submitModle) {
      // console.log(submitModle);
      let urlPrm =
        this.questionnaireRow.UserQuestionnaireID === 0 ? "Create" : "Edit";
      let url = this.$store.state.apiPath + `/api/QuestionnaireUser/${urlPrm}`;
      if (this.isValid) {
        if (submitModle.SubmitStatus) {
          this.xy.confirm(
            "确定提交",
            "提交后问卷不可修改，您确认要提交吗？",
            async () => {
              let res = await this.xyapi.post(url, submitModle);
              console.log(res, "提交");
              if (res && res.data && res.success) {
                this.xy.msgSuc("提交成功！");
                // 提交成功返回问卷
                this.$router.push("/home/myquestionNaire");
              } else {
                this.xy.msgError(res && res.msg ? res.msg : "提交失败");
              }
            }
          );
        } else {
          let res = await this.xyapi.post(url, submitModle);
          // xy.http.post(url, submitModle, function(res) {
          console.log(res, "下一页");
          if (res.success) {
            this.questionnaireRow.UserQuestionnaireID = isNaN(
              parseInt(res.data)
            )
              ? 0
              : parseInt(res.data);
            this.page += 1;
            if (this.page >= this.questionnaireRow.PageCount)
              this.page = this.questionnaireRow.PageCount;
            this.xy.msgSuc("保存成功！");
            this.loadList();
          } else {
            this.xy.msgError(res && res.msg ? res.msg : "保存失败");
          }
        }
      }
    }
  }
};
</script>
<style lang='less' >
#question-options {
  .van-radio {
    width: 50px;
    height: 100px;
  }
  input {
    height: 100%;
    background-color: #fff;
  }
  input:-internal-autofill-selected {
    background-color: #fff !important;
  }
  .danxuan {
    // right: 0;
    // position: absolute;
    // top: 0;
    height: 100%;
    flex: 1;
  }
  .cell-yaya {
    padding: 0;
    border: none;
    .van-field__body {
      box-sizing: border-box;
    }
  }
  .van-radio {
    width: 100%;
  }
  .van-radio__icon .van-icon,
  .van-checkbox__icon {
    border: none;
    position: absolute;
    right: 40px;
    top: 50%;
    transform: translateY(-50%);
  }
  .van-cell__value {
    display: flex;
    label {
      // flex: 1
      line-height: 100px;
      padding-left: 24px;
    }
    .van-field {
      flex: 1;
    }
    .van-checkbox-group {
      flex: 1;
    }
  }
  .van-field__body {
    width: 100%;
  }
  #field {
    width: 100%;
  }
  .van-button--primary {
    background-color: #04be02;
    margin-top: 50px;
    height: 90px;
    line-height: 90px;
    font-size: 30px;
  }
  #danxuan {
    .van-radio__icon {
      width: 100%;
      padding-right: 30px;
    }
    .van-radio__icon img {
      width: 50px;
      float: right;
    }
  }
}
</style>  

